import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from './ErrorBoundary';
import * as Sentry from '@sentry/react';
import { connect } from 'react-redux';
import { selector } from 'apps/services';

const BasePage = ({ children }) => {
  return (
    <div className="wrapper">
      <section className="section-container">
        <Sentry.ErrorBoundary fallback={({ error, componentStack }) => <ErrorBoundary error={error} errorInfo={componentStack} />}>{children}</Sentry.ErrorBoundary>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => selector(state, false, ['authorisation', 'app']);

const mapDispatchToProps = () => {
  return {};
};

BasePage.propTypes = {
  children: PropTypes.object,
  app: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(BasePage);
